export enum ProcessingStatus {
  Unprocessed = 'unprocessed',
  InProgress = 'in-progress',
  Processed = 'processed',
  Failed = 'failed',
}
